"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { COMPANY_VALUES } from "@/constants/about.constants";
export function useValuesTabs() {
  const $ = _c(5);
  const [active, setActive] = useState(0);
  const [openMobile, setOpenMobile] = useState(0);
  const current = COMPANY_VALUES[active];
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = i => setOpenMobile(prev => prev === i ? null : i);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const toggleMobile = t0;
  let t1;
  if ($[1] !== active || $[2] !== current || $[3] !== openMobile) {
    t1 = {
      active,
      setActive,
      openMobile,
      toggleMobile,
      current
    };
    $[1] = active;
    $[2] = current;
    $[3] = openMobile;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}